module.exports = __webpack_public_path__ + "static/media/newsfeed.d024c80e.png";